// extracted by mini-css-extract-plugin
module.exports = {"Upload":"UploadVideo_Upload__YwoTu","Upload__add-btn":"UploadVideo_Upload__add-btn__90oIt"};